import {
  BlissfulIcon,
  CbdIcon,
  EdibleIcon,
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  HybridIcon,
  IndicaIcon,
  LightningIcon,
  MerchIcon,
  NotHighIcon,
  PainFreeIcon,
  PencilIcon,
  PizzaIcon,
  PrerollIcon,
  RelaxedIcon,
  SativaIcon,
  SleepIcon,
  TagIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { ReactElement } from 'react';

export const FeelingIconMap: Record<string, ReactElement> = {
  Blissful: <BlissfulIcon color={null} />,
  cbd: <CbdIcon color={null} />,
  Creative: <PencilIcon color={null} />,
  edible: <EdibleIcon color={null} />,
  Energetic: <LightningIcon color={null} />,
  extract: <ExtractIcon color={null} />,
  flower: <FlowerIcon color={null} />,
  gear: <GearIcon color={null} />,
  Hungry: <PizzaIcon color={null} />,
  hybrid: <HybridIcon color={null} />,
  indica: <IndicaIcon color={null} />,
  merch: <MerchIcon color={null} />,
  'Not high': <NotHighIcon color={null} />,
  'Pain free': <PainFreeIcon color={null} />,
  'pre-roll': <PrerollIcon color={null} />,
  Relaxed: <RelaxedIcon color={null} />,
  Relieved: <PainFreeIcon color={null} />,
  sale: <TagIcon color="info" />,
  sativa: <SativaIcon color={null} />,
  Sleepy: <SleepIcon color={null} />,
  tincture: <TinctureIcon color={null} />,
  topical: <TopicalIcon color={null} />,
  vape: <VapeIcon color={null} />,
};
